(() => {
  const normalizeText = (value) => value.replace(/\s+/g, ' ').trim().toLowerCase();

  const enhanceFaq = (root = document) => {
    const faq = root.querySelector?.('.petal-prose--faq');
    if (!faq || faq.dataset.accordionReady === 'true') return;

    faq.dataset.accordionReady = 'true';
    const originalChildren = Array.from(faq.children);
    const fragment = document.createDocumentFragment();
    let group = null;
    let answer = null;

    const ensureGroup = () => {
      if (group) return group;
      group = document.createElement('section');
      group.className = 'petal-faq-group';
      fragment.append(group);
      return group;
    };

    originalChildren.forEach((node) => {
      if (node.matches('h2')) {
        group = document.createElement('section');
        group.className = 'petal-faq-group';
        node.classList.add('petal-faq-group__title');
        group.append(node);
        fragment.append(group);
        answer = null;
        return;
      }

      if (node.matches('h3')) {
        const details = document.createElement('details');
        details.className = 'petal-faq-item';

        const summary = document.createElement('summary');
        const question = document.createElement('span');
        question.className = 'petal-faq-item__question';
        question.innerHTML = node.innerHTML;

        const toggle = document.createElement('span');
        toggle.className = 'petal-faq-item__toggle';
        toggle.setAttribute('aria-hidden', 'true');

        summary.append(question, toggle);
        answer = document.createElement('div');
        answer.className = 'petal-faq-item__answer';
        details.append(summary, answer);
        ensureGroup().append(details);
        node.remove();
        return;
      }

      if (answer) {
        answer.append(node);
      } else if (group) {
        group.append(node);
      } else {
        fragment.append(node);
      }
    });

    faq.replaceChildren(fragment);
  };

  const refineContactPage = (root = document) => {
    if (!window.location.pathname.includes('/pages/contact')) return;

    const prose = root.querySelector?.('.petal-prose');
    if (!prose || prose.dataset.contactReady === 'true') return;

    prose.dataset.contactReady = 'true';
    prose.classList.add('petal-prose--contact');

    Array.from(prose.querySelectorAll('p')).forEach((paragraph) => {
      const text = normalizeText(paragraph.textContent || '');
      if (text.startsWith('monday') || text.startsWith('saturday')) {
        paragraph.remove();
      }
    });

    if (!prose.querySelector('.petal-contact-note')) {
      const locationHeading = Array.from(prose.querySelectorAll('h2, h3')).find((heading) =>
        normalizeText(heading.textContent || '').includes('everykind collective')
      );
      const address = locationHeading?.nextElementSibling;
      const note = document.createElement('p');
      note.className = 'petal-contact-note';
      note.innerHTML = '<strong>By appointment only.</strong>';

      if (address?.tagName === 'P') {
        address.insertAdjacentElement('afterend', note);
      } else {
        prose.append(note);
      }
    }
  };

  const refineVisitPage = (root = document) => {
    if (!window.location.pathname.includes('/pages/where-to-find-us')) return;
    const prose = root.querySelector?.('.petal-prose');
    if (prose) prose.classList.add('petal-prose--visit');
  };

  const updateFacebookLink = (root = document) => {
    const facebookUrl = 'https://www.facebook.com/isabellamunroart';
    const links = root.querySelectorAll?.(
      'footer a[aria-label="facebook"], footer a[href*="facebook.com/petalandpen.rsa"], footer a[href*="facebook.com/sharer"]'
    );

    links?.forEach((link) => {
      link.href = facebookUrl;
      link.target = '_blank';
      link.rel = 'noopener';
    });
  };

  let scheduled = false;
  const scheduleEnhancements = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      enhanceFaq();
      refineContactPage();
      refineVisitPage();
      updateFacebookLink();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhancements, { once: true });
  } else {
    scheduleEnhancements();
  }

  document.addEventListener('shopify:section:load', scheduleEnhancements);

  const observer = new MutationObserver(scheduleEnhancements);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(() => observer.disconnect(), 12000);
})();
